import { render, staticRenderFns } from "./jobsPromptInfo.vue?vue&type=template&id=707fe84d&scoped=true"
import script from "./jobsPromptInfo.vue?vue&type=script&lang=js"
export * from "./jobsPromptInfo.vue?vue&type=script&lang=js"
import style0 from "./jobsPromptInfo.vue?vue&type=style&index=0&id=707fe84d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707fe84d",
  null
  
)

export default component.exports